import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { PagesIndexScreen } from "../../screens/pages/index.ts";

/**
 * `/pages?area=`: Dashboards, every dashboard and report the company keeps: pinned first, then what you opened
 * lately, then by business area (the sidebar filters by one). "New dashboard" asks Adea in words; the thread where it
 * builds it opens, and the dashboard is here once Adea saves it.
 */
export const Route = createFileRoute("/_app/pages/")({
  validateSearch: (search: Record<string, unknown>): { area?: string } =>
    typeof search.area === "string" && search.area ? { area: search.area } : {},
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(actions.queryOptions("library.get", {}));
    return context.queryClient.prefetchQuery(actions.queryOptions("pages.list", {}));
  },
  component: PagesIndexScreen,
});
